<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Obras</h2>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="new-project" *ngIf="filters?.canCreatWork">
      <a class="btn btn-primary" [routerLink]="['/qrobras/obra/adicionar']">Nova Obra</a>
    </div>
  </div>
</div>

<div class="open-filters" *ngIf="!filterActive">
  <button class="btn-filters-close" type="button" (click)="filterActive = true">
    <img src="assets/images/svgs/Filtros.svg">
  </button>
</div>

<div *ngIf="filterActive" class="wrapper wrapper-content animated fadeInRight" [@slideIn]="filterActive">
  <div class="row">
    <div class="col-12">
      <div class=" float-e-margins">
        <div class="form_search">
          <div class="m-b">
            <div class="form-group form-filter">
              <h3>Filtros</h3>
              <div class="col-8 d-flex justify-content-end">
                <button class="btn-filters" type="button" (click)="cleanSearch()">
                  <img src="assets/images/svgs/Limpar_filtros.svg">
                  <span>Limpar Filtros</span>
                </button>
                <button class="btn-filters-close" type="button" (click)="closeFilter()">
                  <img src="assets/images/svgs/Fechar.svg" alt="Pesquisar">
                </button>
              </div>
            </div>
          </div>
          <form [formGroup]="form">
            <div class="form-group row">
              <div class="m-b col-sm-4">
                <label class="col-sm-12 pb-1">Status</label>
                <ng-select id="filter_status" class="ng-select-alternative" [items]="filters?.statusList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_status">
                </ng-select>
              </div>
              <div class="m-b col-sm-4">
                <label class="col-sm-12 pb-1">Órgão</label>
                <ng-select id="filter_agency" class="ng-select-alternative" [items]="filters?.agencyList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_agency">
                </ng-select>
              </div>
              <div class="m-b col-sm-4">
                <label class="col-sm-12 pb-1">Munícipio</label>
                <ng-select id="filter_city" class="ng-select-alternative" [items]="filters?.cityList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_city">
                </ng-select>
              </div>
            </div>
            <div class="form-group row">
              <div class="m-b col-sm-4">
                <label class="col-sm-12 pb-1">Responsável</label>
                <ng-select id="filter_main_manager" class="ng-select-alternative" [items]="filters?.personList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_main_manager">
                </ng-select>
              </div>
              <div class="m-b col-sm-4">
                <label class="col-sm-12 pb-1">Órgão do Projeto</label>
                <ng-select id="filter_project_full_id" class="ng-select-alternative" [items]="filters?.projectFullList" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_project_full_id">
                </ng-select>
              </div>

              <div class="col-sm-4 m-b">
                <div class="search-button">
                  <button type="button" (click)="search(true)">Filtrar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="system-table">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="title-width">Id</th>
          <th class="text-center">Titulo</th>
          <th class="text-center">Órgão</th>
          <th class="text-center">Ident. no Órgão</th>
          <th class="text-center">Munícipios</th>
          <th class="text-center">Atualização</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let obra of obrasList">
          <tr>
            <td class="title">{{ obra?.id }}</td>
            <td class="text-center"><span class="title-span">{{obra?.title}}</span></td>
            <td class="text-center">{{ obra?.agency_acron }}</td>
            <td class="text-center">{{ obra?.code }}</td>
            <td class="text-center">{{ obra?.city_names }}</td>
            <td class="text-center">
              <div class="m-b-xs">{{obra?.ctr_usu_atu_name}}</div>
              {{obra?.ctr_dth_atu}}
            </td>
            <td>
              <div class="btn-icon btn-icon-auto">
                <a [routerLink]="['/qrobras/obra/', obra.id]" class="icon-table">
                  <img src="assets/images/svgs/lupa.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!obrasList?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum Obra Encontrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>